/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Company_InfoInputs */

const vi_invoice_company_info = /** @type {(inputs: Invoice_Company_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin công ty`)
};

/**

* @param {Invoice_Company_InfoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_company_info = /** @type {((inputs?: Invoice_Company_InfoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Company_InfoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_company_info(inputs)
});